// @flow
import type {
  ProfileAction,
  User,
} from '../types';

import * as actionTypes from './actionTypes';


export const fillProfile = (
  payload: User,
): ProfileAction => ({
  type: actionTypes.FILL_PROFILE,
  payload,
});
